// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General styling for the container */
.content {
  height: 100vh; /* Ensure full viewport height */
  overflow: hidden; /* Prevent scrolling on the page itself */
  position: relative; /* Allow children to position relative to this */
  padding: 10px;
}

.tab-content {
  height: 100%; /* Prevent content from expanding beyond the container */
  max-height: 100%; /* Add an internal scroll for large content */
  overflow: auto;
  padding: 10px;
  box-sizing: border-box;
}

/* Ensures as-split and its areas take the full height */
.as-split {
  flex: 1; /* Allows as-split to grow and fill the parent */
  height: 100%; /* Fills the .content height */
}

as-split-area {
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevents content spill */
}

/* Scrollable content within each split area */
.scrollable {
  flex: 1;
  overflow: auto; /* Enables scrolling only within the area */
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

/* Toolbar adjustments */
.llm-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 10px;
}

.llm-monaco-container {
  height: 100%;
}

ngx-monaco-editor {
  height: 100%; /* Ensure it fills the parent container */
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.secondary-editor {
  height: 200px;
}

mat-tab-group {
  height: calc(100% - 40px) !important;
}

.model-listing {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}
.model-listing .model-description {
  font-size: 0.75rem;
  line-height: 1rem;
}

.analysis-container {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.analysis-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.prompt-name-input {
  flex: 1;
  margin-right: 10px;
}

mat-icon-button {
  height: 36px;
  width: 36px;
}

.secondary-editor {
  height: 200px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.add-prompt-button {
  margin-top: 20px;
}

.mat-tab-group {
  height: calc(100% - 40px) !important;
  display: flex;
  flex-direction: column;
}

.tab-content {
  display: flex;
  flex-direction: column;
  height: 100%; /* Ensures the content fills the available space */
  box-sizing: border-box;
}

.prompt-name-input {
  flex: 0 0 auto; /* Ensures the input does not stretch */
}

.monaco-editor {
  flex: 1 1 auto; /* Ensures the editor stretches to fill available space */
  min-height: 200px; /* Optional: Set a minimum height */
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

button[mat-icon-button] {
  margin-left: auto; /* Aligns the delete button to the right */
}

::ng-deep .prompt-name-input .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mat-tab-group ::ng-deep .mat-mdc-tab-label:last-child {
  flex: 0 0 auto; /* Prevent the tab from stretching */
  min-width: 40px; /* Set a smaller minimum width */
  max-width: 40px; /* Set a smaller maximum width */
  padding: 0; /* Remove unnecessary padding */
  margin: 0; /* Remove unnecessary margins */
}

.add-tab-button {
  width: 32px; /* Size of the button */
  height: 32px; /* Size of the button */
  margin: 0 auto; /* Center it inside the tab */
  padding: 0; /* Remove extra padding */
  display: flex;
  justify-content: center;
  align-items: center;
}

.prompt-name-row {
  display: flex;
  align-items: center; /* Vertically align items */
  gap: 8px; /* Add spacing between the input and delete button */
}

.prompt-name-input {
  flex: 1; /* Allow the input to take up available space */
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/strategy-editor-widget/strategy-editor-widget.component.scss"],"names":[],"mappings":"AAAA,sCAAA;AACA;EACE,aAAA,EAAA,gCAAA;EACA,gBAAA,EAAA,yCAAA;EACA,kBAAA,EAAA,gDAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA,EAAA,wDAAA;EACA,gBAAA,EAAA,6CAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA,wDAAA;AACA;EACE,OAAA,EAAA,gDAAA;EACA,YAAA,EAAA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA,EAAA,2BAAA;AACF;;AAEA,8CAAA;AACA;EACE,OAAA;EACA,cAAA,EAAA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA,wBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA,EAAA,yCAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;AAAF;AAEE;EACE,kBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AADF;;AAIA;EACE,OAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,oCAAA;EACA,aAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA,EAAA,kDAAA;EACA,sBAAA;AADF;;AAIA;EACE,cAAA,EAAA,uCAAA;AADF;;AAIA;EACE,cAAA,EAAA,yDAAA;EACA,iBAAA,EAAA,mCAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AADF;;AAIA;EACE,iBAAA,EAAA,0CAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,cAAA,EAAA,oCAAA;EACA,eAAA,EAAA,gCAAA;EACA,eAAA,EAAA,gCAAA;EACA,UAAA,EAAA,+BAAA;EACA,SAAA,EAAA,+BAAA;AADF;;AAIA;EACE,WAAA,EAAA,uBAAA;EACA,YAAA,EAAA,uBAAA;EACA,cAAA,EAAA,6BAAA;EACA,UAAA,EAAA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA,EAAA,2BAAA;EACA,QAAA,EAAA,oDAAA;AADF;;AAIA;EACE,OAAA,EAAA,+CAAA;AADF","sourcesContent":["/* General styling for the container */\n.content {\n  height: 100vh; /* Ensure full viewport height */\n  overflow: hidden; /* Prevent scrolling on the page itself */\n  position: relative; /* Allow children to position relative to this */\n  padding: 10px;\n}\n\n.tab-content {\n  height: 100%; /* Prevent content from expanding beyond the container */\n  max-height: 100%; /* Add an internal scroll for large content */\n  overflow: auto;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n/* Ensures as-split and its areas take the full height */\n.as-split {\n  flex: 1; /* Allows as-split to grow and fill the parent */\n  height: 100%; /* Fills the .content height */\n}\n\nas-split-area {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* Prevents content spill */\n}\n\n/* Scrollable content within each split area */\n.scrollable {\n  flex: 1;\n  overflow: auto; /* Enables scrolling only within the area */\n  padding: 10px;\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n}\n\n/* Toolbar adjustments */\n.llm-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 10px;\n}\n\n.llm-monaco-container {\n  height: 100%;\n}\n\nngx-monaco-editor {\n  height: 100%; /* Ensure it fills the parent container */\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.secondary-editor {\n  height: 200px;\n}\n\nmat-tab-group {\n  height: calc(100% - 40px)!important;\n}\n\n\n.model-listing {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n\n  .model-description {\n    font-size: 0.75rem;\n    line-height: 1rem;\n  }\n}\n\n.analysis-container {\n  margin-bottom: 20px;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background-color: #f9f9f9;\n}\n\n.analysis-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.prompt-name-input {\n  flex: 1;\n  margin-right: 10px;\n}\n\nmat-icon-button {\n  height: 36px;\n  width: 36px;\n}\n\n.secondary-editor {\n  height: 200px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.add-prompt-button {\n  margin-top: 20px;\n}\n\n.mat-tab-group {\n  height: calc(100% - 40px)!important;\n  display: flex;\n  flex-direction: column;\n}\n\n.tab-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%; /* Ensures the content fills the available space */\n  box-sizing: border-box;\n}\n\n.prompt-name-input {\n  flex: 0 0 auto; /* Ensures the input does not stretch */\n}\n\n.monaco-editor {\n  flex: 1 1 auto; /* Ensures the editor stretches to fill available space */\n  min-height: 200px; /* Optional: Set a minimum height */\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\nbutton[mat-icon-button] {\n  margin-left: auto; /* Aligns the delete button to the right */\n}\n\n::ng-deep .prompt-name-input .mat-mdc-form-field-subscript-wrapper {\n  display: none;\n}\n\n.mat-tab-group ::ng-deep .mat-mdc-tab-label:last-child {\n  flex: 0 0 auto; /* Prevent the tab from stretching */\n  min-width: 40px; /* Set a smaller minimum width */\n  max-width: 40px; /* Set a smaller maximum width */\n  padding: 0; /* Remove unnecessary padding */\n  margin: 0; /* Remove unnecessary margins */\n}\n\n.add-tab-button {\n  width: 32px; /* Size of the button */\n  height: 32px; /* Size of the button */\n  margin: 0 auto; /* Center it inside the tab */\n  padding: 0; /* Remove extra padding */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.prompt-name-row {\n  display: flex;\n  align-items: center; /* Vertically align items */\n  gap: 8px; /* Add spacing between the input and delete button */\n}\n\n.prompt-name-input {\n  flex: 1; /* Allow the input to take up available space */\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
